(() => {
  const root = document.querySelector(".mono-page");
  const toggle = document.querySelector(".lang-toggle");
  const label = document.querySelector("[data-lang-label]");
  if (!root || !toggle || !label) return;

  const applyLanguage = (lang) => {
    root.dataset.lang = lang;
    document.documentElement.lang = lang;
    label.textContent = lang === "de" ? "EN" : "DE";
    label.setAttribute("aria-label", lang === "de" ? "Switch to English" : "Auf Deutsch wechseln");
    window.localStorage.setItem("mono-lang", lang);
  };

  toggle.addEventListener("click", () => applyLanguage(root.dataset.lang === "de" ? "en" : "de"));
  applyLanguage(window.localStorage.getItem("mono-lang") === "en" ? "en" : "de");
})();

(() => {
  const input = document.querySelector("[data-knowledge-search]");
  const items = [...document.querySelectorAll("[data-knowledge-item]")];
  const empty = document.querySelector("[data-knowledge-empty]");
  if (!input || !items.length) return;
  input.addEventListener("input", () => {
    const query = input.value.trim().toLowerCase();
    let visible = 0;
    items.forEach((item) => {
      const match = !query || (item.dataset.search || item.textContent || "").toLowerCase().includes(query);
      item.hidden = !match;
      if (match) visible += 1;
    });
    if (empty) empty.hidden = visible !== 0;
  });
})();

(() => {
  const buttons = [...document.querySelectorAll("[data-like-key]")];
  buttons.forEach((button) => {
    const key = `mono-like:${button.dataset.likeKey}`;
    const count = button.querySelector("[data-like-count]");
    const applyState = () => {
      const liked = window.localStorage.getItem(key) === "1";
      button.classList.toggle("is-liked", liked);
      button.setAttribute("aria-pressed", liked ? "true" : "false");
      if (count) count.textContent = liked ? "1" : "0";
    };
    applyState();
    button.addEventListener("click", () => {
      if (window.localStorage.getItem(key) === "1") window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, "1");
      applyState();
    });
  });
})();

(() => {
  const content = document.querySelector("[data-article-content]");
  const toc = document.querySelector("[data-article-toc]");
  const list = document.querySelector("[data-article-toc-list]");
  if (!content || !toc || !list) return;

  const headings = [...content.querySelectorAll("h2, h3")];
  if (headings.length < 2) return;

  const usedIds = new Set();
  headings.forEach((heading, index) => {
    const source = heading.textContent.trim();
    let id = heading.id || source
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "") || `section-${index + 1}`;
    const baseId = id;
    let suffix = 2;
    while (usedIds.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) id = `${baseId}-${suffix++}`;
    usedIds.add(id);
    heading.id = id;
    heading.classList.toggle("article-sources-heading", /quellen|sources/i.test(source));

    const link = document.createElement("a");
    link.href = `#${id}`;
    link.textContent = source;
    if (heading.tagName === "H3") link.className = "is-subheading";
    list.appendChild(link);
  });

  toc.hidden = false;
})();
